import { useEffect, useState, useRef } from 'react';

import logger from '@eb/logger-bugsnag';

import { getUser, getUserOrders } from '../api';
import { getOrdersInRange } from '../lib/orders';
import { checkIfEventLive } from '../lib/dates';

export const useAttendeeData = ({ hoursAheadPreview, isAuthenticated }) => {
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const getUserData = async () => {
            let isUserAuthenticated = isAuthenticated;

            if (userData === null) {
                if (typeof isUserAuthenticated !== 'boolean') {
                    try {
                        const user = await getUser();

                        if (user) {
                            isUserAuthenticated = true;
                        }
                    } catch {
                        //Expected failure here if the user isn't
                        //logged in. No need to log issue.
                        setUserData(false);
                    }
                }

                if (isUserAuthenticated) {
                    try {
                        const userOrders = await getUserOrders();
                        const userOrdersInRange = getOrdersInRange(
                            userOrders.orders,
                            hoursAheadPreview,
                        );

                        setUserData({ userOrders: userOrdersInRange });
                    } catch (error) {
                        logger.error('Error getting user orders:', {
                            error: error.message ? error.message : error,
                        });

                        setUserData(false);
                    }
                }
            }
        };

        getUserData();
    }, [hoursAheadPreview, userData, isAuthenticated]);

    return userData;
};

export const useIsLiveEvent = (localizedEventStart) => {
    const [isLive, setLive] = useState(checkIfEventLive(localizedEventStart));
    const intervalId = useRef(null);

    const clearInterval = () => {
        if (intervalId.current) {
            const invtervalId = intervalId.current;
            intervalId.current = null;

            window.clearInterval(invtervalId);
        }
    };

    const intervalCallBack = () => {
        const isEventLive = checkIfEventLive(localizedEventStart);

        if (isEventLive) {
            setLive(true);
            clearInterval();
        }

        return;
    };

    if (!isLive && !!localizedEventStart && !intervalId.current) {
        intervalId.current = window.setInterval(intervalCallBack, 10000);
    }

    useEffect(() => {
        setLive(checkIfEventLive(localizedEventStart));
    }, [localizedEventStart]);

    return isLive;
};
